import { connect, MapStateToProps } from 'react-redux';
import { Props } from './TFAVerificationPage';
import { AppState } from '../../../types/store';

type StateProps = Pick<
  Props,
  'user' | 'remember' | 'isVerificationCodeInvalid' | 'isRecoveryCodeInvalid'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (state: AppState) => {
  return {
    user: state.login.tfaUserData || ({} as any), // Provide fallback object
    remember: state.login.remember,
    isVerificationCodeInvalid: state.login.tfaVerificationCodeInvalid,
    isRecoveryCodeInvalid: state.login.tfaRecoveryCodeInvalid,
  };
};

export default connect(mapStateToProps);
